import { mixpanel, getMixpanelSubscriptionStatus, getQueueProductsCount, getDaysFromFirstSubscription } from 'common/helpers'


const mixpanelMiddleware = () => (store) => (next) => (action) => {
  const { rootType, payload } = action

  const {
    models: {
      subscription: { status },
      queue: { items: oldItems },
      me: { stats: oldStats, daysFromFirstSubscription },
    },
  } = store.getState()

  const result = next(action)

  // check var propertiesToSync in mixpanel.script.js
  let isMixpanelSuperPropsModified = false

  if (
    rootType === 'models.subscription.update'
    && payload.status
    && payload.status !== status
  ) {
    mixpanel.register({
      'Subscription Status': getMixpanelSubscriptionStatus(payload.status),
    })
  }

  if (
    rootType === 'models.queue.setItems'
    || rootType === 'models.queue.addItem'
  ) {
    const { count: queueItemsOldCount } = getQueueProductsCount(oldItems)

    // store is new here
    const { models: { queue: { items: newItems } } } = store.getState()
    const { count: queueItemsNewCount } = getQueueProductsCount(newItems)

    if (queueItemsNewCount !== queueItemsOldCount) {
      mixpanel.register({
        'Products in Queue': queueItemsNewCount,
      })

      isMixpanelSuperPropsModified = true
    }
  }

  if (rootType === 'models.me.update') {
    if (payload.stats && payload.stats.ratedProducts !== oldStats.ratedProducts) {
      mixpanel.people.set({
        productsRated: payload.stats.ratedProducts,
      })
    }

    // it may be null and it's ok so check undefined only
    if (typeof payload.daysFromFirstSubscription !== 'undefined' && payload.daysFromFirstSubscription !== daysFromFirstSubscription) {
      const days = getDaysFromFirstSubscription(payload.daysFromFirstSubscription)

      mixpanel.register({
        'Days after first subscription': days,
      })

      isMixpanelSuperPropsModified = true
    }

    if (payload.isLoggedIn && payload.paymentProvider) {
      const isRecurly = payload.paymentProvider === 'RECURLY'

      mixpanel.register({
        'Recurly': isRecurly,
      })

      if (isRecurly) {
        isMixpanelSuperPropsModified = true
      }
    }
  }

  if (isMixpanelSuperPropsModified && typeof window.syncMixpanelSuperPropertiesCookie === 'function') {
    window.syncMixpanelSuperPropertiesCookie()
  }

  return result
}


export default mixpanelMiddleware
